$(document).ready(function () {
    var $serviceHeroReviews = $('.js-service-hero-reviews');

    if (!$serviceHeroReviews.length) {
        return;
    }

    // Click-and-drag scrolling with a mouse - native overflow-x: auto
    // already gives touch swipe for free, but not mouse drag. Same
    // dragging class/cursor-swap convention as reviews-strip.js's slick
    // instance (see .js-reviews-strip's .slick-list.dragging), though
    // this is a plain scroll container, not a slick carousel, so it's
    // driven by hand here instead.
    var isDragging = false;
    var dragStartX = 0;
    var dragStartScrollLeft = 0;

    $serviceHeroReviews.on('mousedown', function (e) {
        isDragging = true;
        $(this).addClass('dragging');
        dragStartX = e.pageX;
        dragStartScrollLeft = this.scrollLeft;
    });

    // On the window, not just the list, so a drag that ends (or a mouse
    // that's released) outside the list while dragging still stops it -
    // mouseup/mouseleave on the list alone would miss that.
    $(window).on('mouseup mouseleave', function () {
        isDragging = false;
        $serviceHeroReviews.removeClass('dragging');
    });

    $serviceHeroReviews.on('mousemove', function (e) {
        if (!isDragging) {
            return;
        }

        // Prevents text/image selection while dragging.
        e.preventDefault();

        this.scrollLeft = dragStartScrollLeft - (e.pageX - dragStartX);
    });
});
